import { RequiredFileType } from '@nemuru-eng/js-api-client';

import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const RequiredFileTypesOptions = (requiredFileTypes?: RequiredFileType[]) => {
  const { getTextIdTranslation } = useTranslation();

  return requiredFileTypes
    ? Object.values(requiredFileTypes).map((value) => ({
        value: value.id,
        display: getTextIdTranslation(value.name) || value.name,
      }))
    : [];
};
